import React, { createContext, useContext, useState } from 'react';

// Create the context
const AppContext = createContext();

// Custom hook to use the AppContext
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

// Provider component
export const AppProvider = ({ children }) => {
  const [currentView, setCurrentView] = useState('home');
  const [params, setParams] = useState({});

  // Navigate function to parse path and update state
  const navigate = (path) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;

    // Split path into segments
    const segments = cleanPath.split('/').filter(segment => segment.length > 0);

    // Default to home if no path
    if (segments.length === 0) {
      setCurrentView('home');
      setParams({});
      return;
    }

    const firstSegment = segments[0];

    // Handle different route patterns
    switch (firstSegment) {
      case 'video':
        setCurrentView('video');
        if (segments.length >= 2) {
          const videoParams = { video: segments[1] };
          setParams(videoParams);
        } else {
          setParams({});
        }
      break;

      default:
        // Unknown route, default to firstSegment
        setCurrentView(firstSegment);
        setParams({});
      break;
    }
  };

  const value = {
    currentView,
    params,
    navigate,
    setCurrentView,
    setParams
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;